// PRODUCT ACCORDION 
const ACCORDION_DURATION = 280;
const ACCORDION_EASING = "cubic-bezier(0.4, 0, 0.2, 1)";

class ProductAccordion extends HTMLElement {
  connectedCallback() {
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.items = Array.from(this.querySelectorAll(":scope > details.accordion_item"));

    this.items.forEach((item) => {
      const summary = item.querySelector("summary.accordion_summary");
      if (!summary) return;

     
      summary.addEventListener("click", (event) => {
        event.preventDefault();
        item.open ? this.close(item) : this.open(item);
      });
    });
  }

  open(item) {
    this.items.forEach((other) => {
      if (other !== item && other.open) this.close(other);
    });

    const panel = item.querySelector(".accordion_panel");
    if (!panel) {
      item.open = true;
      return;
    }

   
    const from = item.open ? panel.getBoundingClientRect().height : 0;
    item.open = true;
    this.animate(item, panel, from, panel.scrollHeight);
  }

  close(item) {
    const panel = item.querySelector(".accordion_panel");
    if (!panel) {
      item.open = false;
      return;
    }

    this.animate(item, panel, panel.getBoundingClientRect().height, 0, () => {
      item.open = false;
    });
  }

  
  animate(item, panel, from, to, onFinish) {
    item.accordionAnimation?.cancel();

    if (this.reducedMotion.matches) {
      onFinish?.();
      return;
    }

    const animation = panel.animate(
      {
        height: [`${from}px`, `${to}px`],
        opacity: [from === 0 ? 0 : 1, to === 0 ? 0 : 1],
      },
      { duration: ACCORDION_DURATION, easing: ACCORDION_EASING },
    );

    item.accordionAnimation = animation;

    animation.onfinish = () => {
      item.accordionAnimation = null;
      onFinish?.();
    };

    animation.oncancel = () => {
      item.accordionAnimation = null;
    };
  }


  openItem(item) {
    if (!item || item.open) return;
    this.open(item);
  }
}

customElements.define("product-accordion", ProductAccordion);

// READ MORE
document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-accordion-target]");
  if (!trigger) return;

  const target = document.getElementById(trigger.dataset.accordionTarget);
  if (!target) return;

  const accordion = target.closest("product-accordion");
  if (typeof accordion?.openItem === "function") {
    accordion.openItem(target);
  } else {
    target.open = true;
  }

  const headerOffset =
    parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10) || 0;
  const offset = headerOffset + 24;

  if (typeof lenis !== "undefined" && lenis?.scrollTo) {
    lenis.scrollTo(target, { offset: -offset });
  } else {
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
});
